const YMX = require('../list/en/YMX');

module.exports = {
  title: 'AiFeiBaiHuo',
  login: {
    username: 'Please enter the user name',
    password: 'Please enter your password',
    Username: 'Username',
    Password: 'Password',
    login: 'login',
    Email: 'Email',
    Mobile: 'Mobile',
    register: 'register',
    CreateAnAccount: 'Create an account',
    exit: 'exit',
    ForgotPassword: 'Forgot password',
    CreateAccount: 'Create account',
    RegisterType: 'Register by',
    VerificationCode: 'Verification Code',
    phone: 'Phone',
    inspectPassword: 'Confirm password',
    Emailverify: 'The email address cannot be left blank.',
    Passwordverify: 'The password cannot be empty',
    inspectPasswordverify: 'Confirm that the password cannot be empty',
    Phoneverify: 'The phone number cannot be empty',
    Passwordformat:
      'The password format is incorrect. The password must be longer than 3',
    inspectPasswordformat:
      'Password format error. Length must be >3 and must match the password.',
    userNameverify: 'The user name cannot be empty',
  },
  home: {
    Categories: 'Categories',
    search: 'search',
    lang: 'EN',
    placeholder: 'Search for products/stores',
  },
  Goods: {
    CartBtn: 'Add to cart',
    BuyBtn: 'Buy now',
    Subtotal: 'Subtotal',
  },
  form: {
    submit: 'Submit',
  },
  // ...YMX,
  YMX,
};
